import { render } from "./SidenavItem.vue?vue&type=template&id=6ede82dd"
import script from "./SidenavItem.vue?vue&type=script&lang=js"
export * from "./SidenavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/Sidenav/SidenavItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ede82dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ede82dd', __exports__)) {
    api.reload('6ede82dd', __exports__)
  }
  
  module.hot.accept("./SidenavItem.vue?vue&type=template&id=6ede82dd", () => {
    api.rerender('6ede82dd', render)
  })

}


export default __exports__